<template>
  <div class="container text-center my-4">
    <h2>Registro</h2>
    <input v-model="firstName" type="text" class="form-control my-2" placeholder="Nombre" />
    <input v-model="lastName" type="text" class="form-control my-2" placeholder="Apellido Paterno" />
    <input v-model="birthDate" type="date" class="form-control my-2" placeholder="Fecha de Nacimiento" />
    <input v-model="password" type="password" class="form-control my-2" placeholder="Contraseña" />
    <input v-model="confirmPassword" type="password" class="form-control my-2" placeholder="Repetir Contraseña" />
    
    <div class="form-check my-2">
      <input v-model="acceptTerms" type="checkbox" class="form-check-input" id="terms" />
      <label class="form-check-label" for="terms">Acepto los términos y condiciones</label>
    </div>
    <div class="form-check my-2">
      <input v-model="acceptMarketing" type="checkbox" class="form-check-input" id="marketing" />
      <label class="form-check-label" for="marketing">Acepto recibir comunicaciones de marketing</label>
    </div>

    <button class="btn btn-success" @click="register">Registrarse</button>
    <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      birthDate: '',
      password: '',
      confirmPassword: '',
      acceptTerms: false,
      acceptMarketing: false,
      errorMessage: '',
    };
  },
  methods: {
    register() {
      const ageLimit = 18;
      const birthDate = new Date(this.birthDate);
      const age = new Date().getFullYear() - birthDate.getFullYear();
      if (age < ageLimit || isNaN(age)) {
        this.errorMessage = 'Debes ser mayor de edad para registrarte.';
      } else if (this.password !== this.confirmPassword) {
        this.errorMessage = 'Las contraseñas no coinciden.';
      } else if (!this.acceptTerms) {
        this.errorMessage = 'Debes aceptar los términos y condiciones.';
      } else {
        this.$router.push('/welcome');
      }
    },
  },
};
</script>
